import { type ReactNode } from 'react';
import classNames from 'classnames';
import IcCheck from '@/assets/icons/Check.svg?react';
import IcCirclePartial from '@/assets/icons/CirclePartial.svg?react';
import IcCross from '@/assets/icons/Cross.svg?react';
import styles from './SuccessBanner.module.scss';

export type SuccessBannerTone = 'success' | 'progress';

interface SuccessBannerProps {
  title: ReactNode;
  subtitle: ReactNode;
  onDismiss: () => void;
  dismissLabel: string;
  tone?: SuccessBannerTone;
}

const SuccessBanner = ({
  title,
  subtitle,
  onDismiss,
  dismissLabel,
  tone = 'success',
}: SuccessBannerProps) => {
  const isProgress = tone === 'progress';

  return (
    <div
      className={classNames(styles.banner, {
        [styles.banner_progress]: isProgress,
      })}
      role="status"
    >
      <span
        className={classNames(styles.iconWrap, {
          [styles.iconWrap_progress]: isProgress,
        })}
        aria-hidden="true"
      >
        {isProgress ? (
          <IcCirclePartial
            className={classNames(styles.icon, styles.icon_spin)}
          />
        ) : (
          <IcCheck className={styles.icon} />
        )}
      </span>
      <div className={styles.text}>
        <strong
          className={classNames(styles.title, {
            [styles.title_progress]: isProgress,
          })}
        >
          {title}
        </strong>
        <span className={styles.subtitle}>{subtitle}</span>
      </div>
      <button
        type="button"
        className={styles.dismiss}
        onClick={onDismiss}
        aria-label={dismissLabel}
      >
        <IcCross aria-hidden="true" />
      </button>
    </div>
  );
};

export default SuccessBanner;
